import React, { useState } from "react";
import { toast } from "react-toastify";
import { submitJoinTable } from "../services/joinTableService";
interface JoinTableModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const JoinTableModal: React.FC<JoinTableModalProps> = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [errors, setErrors] = useState<any>({});
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const validate = () => {
    const newErrors: any = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Invalid email";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[0-9]{7,10}$/.test(formData.phone)) {
      newErrors.phone = "Enter valid phone number";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      setLoading(true);

      const response = await submitJoinTable(formData);

      localStorage.setItem("hob-member", "true");
      toast.success("Form submitted successfully!");
      onClose();
      setFormData({
        name: "",
        email: "",
        phone: "",
      });
    } catch (error: any) {
      console.error(error);
      onClose();

      if (error.status === 409) {
        toast.error(error.message);
        setFormData({
          name: "",
          email: "",
          phone: "",
        });
      } else toast.success("Error occurred while form submission");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="join-modal-overlay">
      <div className="join-modal">
        <button className="modal-close" onClick={onClose}>
          ✕
        </button>

        <h2>Become a Member</h2>

        {/* <h2>A Seat Awaits</h2> */}

        <p className="modal-description">
          Join our membership program to receive exclusive dining offers, early
          access to special events, curated updates, and insider news. Complete
          the form below and stay connected with House of Bombay.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              placeholder="NAME"
              value={formData.name}
              maxLength={30}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  name: e.target.value,
                })
              }
            />
            {errors.name && <span>{errors.name}</span>}
          </div>

          <div className="form-group">
            <input
              type="email"
              placeholder="EMAIL ADDRESS"
              value={formData.email}
              maxLength={30}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  email: e.target.value,
                })
              }
            />
            {errors.email && <span>{errors.email}</span>}
          </div>

          <div className="form-group">
            <input
              type="text"
              placeholder="PHONE NUMBER"
              value={formData.phone}
              maxLength={12}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  phone: e.target.value,
                })
              }
            />
            {errors.phone && <span>{errors.phone}</span>}
          </div>

          <button type="submit" className="submit-btn">
            {loading ? "PLEASE WAIT..." : "JOIN NOW"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default JoinTableModal;
